import React, { useEffect, useRef, useState } from "react";
import JobCard from "./FindJobs/JobCard";
import { useJobProvider } from "../../../Providers/Vendor/Jobs";
import { CircularProgress, TablePagination } from "@mui/material";

export default function FindJobs() {
  const [searchText, setSearchText] = useState("");
  const [jobs, setJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const { fetchPublicJobs, loading } = useJobProvider();

  const fetchData = (page, limit) => {
    fetchPublicJobs(page, limit, searchText)
      .then((result) => {
        setJobs(result.rows);
        setTotal(result.totalItems);
        setTotalPages(result.totalPages);
      })
      .catch((err) => console.log(err));
  };
  const handleSearch = async () => {
    fetchData(0, limit);
  };

  useEffect(() => {
    (async () => {
      const result = await fetchPublicJobs(currentPage, limit, searchText);
      if (result) {
        setJobs(result.rows);
        setTotal(result.totalItems);
        setTotalPages(result.totalPages);
      }
    })();
  }, []);

  const handleChangePage = (event, newPage) => {
    scrollToTop();
    setCurrentPage(newPage);
    fetchData(newPage, limit);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    fetchData(0, parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  useEffect(() => {}, [jobs]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  };

  return (
    <div className="py-4 px-8 font-[Roboto] bg-white rounded-lg shadow-md shadow-gray-400">
      <>
        <div>
          {/* TODO: After implementation of routing code use useTheme hook to get primary color*/}
          <h1
            className="text-2xl font-semibold py-6"
            style={{ color: "#2EBAA3" }}
          >
            Find Jobs
          </h1>
          {/* <h1 className="text-2xl font-semibold py-6" style={{color: theme.palette.primary1Color}}>Find Jobs</h1> */}
          <div className="flex md:flex-row flex-col md:space-x-2 md:space-y-0 space-y-2">
            <input
              className="border-[1px] border-[#C6C6C6] border-solid"
              placeholder="Search Here..."
              onChange={(e) => setSearchText(e.target.value)}
              style={{
                // border: "1px solid #C6C6C6",
                borderRadius: "4px",
                width: "100%",
                height: "45px",
                paddingLeft: "10px",
              }}
            />
            <button
              style={{
                width: "168px",
                height: "45px",
                background: "#139588",
                border: "1px solid #C6C6C6",
                borderRadius: "4px",
                color: "white",
              }}
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
        </div>
        <div className="pt-4">
          {jobs.length > 0
            ? jobs.map((job, index) => {
                return (
                  <JobCard details={job} />
                );
              })
            : null}
        </div>
        {!loading && searchText.length > 0 && jobs.length === 0 ? (
          <h1 className="text-center py-20">No results found</h1>
        ) : null}
        {loading ? (
          <div className="text-center py-20">
            <CircularProgress />
          </div>
        ) : null}
        <TablePagination
          component="div"
          count={total}
          page={currentPage}
          onPageChange={handleChangePage}
          rowsPerPage={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </>
    </div>
  );
}
